import { createQueryKeys, type inferQueryKeys } from '@lukemorales/query-key-factory';
import type {
  GetHistoriesReq,
  GetHistoryDetailReq,
  GetPenaltyInfoReq,
  GetPostCampaignOverviewReq,
} from './mapper';
import {
  getHistories,
  getHistoryDetail,
  getPenaltyInfo,
  getPostCampaignOverview,
  getPostCampaigns,
} from './mapper';

export const postingViewingQueryKey = createQueryKeys('posting', {
  all: null,
  availableList: {
    queryFn: async () => {
      const data = await getPostCampaigns();
      return data;
    },
    queryKey: null,
  },
  histories: (params: GetHistoriesReq) => ({
    queryFn: async () => {
      const data = await getHistories(params);
      return data;
    },
    queryKey: [{ ...params }],
  }),
  historyDetail: (params: GetHistoryDetailReq) => ({
    queryFn: async () => {
      const data = await getHistoryDetail(params);
      return data;
    },
    queryKey: [{ ...params }],
  }),
  overviewList: (params: GetPostCampaignOverviewReq) => ({
    queryFn: async () => {
      const data = await getPostCampaignOverview(params);
      return data;
    },
    queryKey: [{ ...params }],
  }),
  penaltyInfo: (params: GetPenaltyInfoReq) => ({
    queryFn: async () => {
      const data = await getPenaltyInfo(params);
      return data;
    },
    queryKey: [{ ...params }],
  }),
});

export type PostingQueryKey = inferQueryKeys<typeof postingViewingQueryKey>;
